import { SET_HIDDEN_HOME_WIDGETS } from "./homeWidgetConstants";
import db from "../../db";

export function setHomeWidgetsAction(hiddenHomeWidgets) {
    return {
        type: SET_HIDDEN_HOME_WIDGETS,
        hiddenHomeWidgets,
    };
}

export function hideWidget(moduleCode, userId) {
    return (dispatch) => {
        db.HiddenHomeWidgets.put({ moduleCode: moduleCode, userId }).then(() => {
            dispatch(loadHiddenWidgets(userId))
        });
    };
}

export function loadHiddenWidgets(userId) {
    return (dispatch) => {
        db.HiddenHomeWidgets.where({ userId: userId }).toArray()
            .then((hiddenHomeWidgets) => {
                dispatch(setHomeWidgetsAction(hiddenHomeWidgets));
            });
    };
}

export function clearHiddenHomeWidgets(userId) {
    return (dispatch) => {
        db.HiddenHomeWidgets.where({ userId: userId }).delete().then(() => {
            dispatch(loadHiddenWidgets(userId));
        });
    }
}
